module.exports = __webpack_public_path__ + "static/media/qr-code-footer.f0fdd29d.png";